var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3426_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9944 79.9887C62.0826 79.9887 79.9887 62.0826 79.9887 39.9944C79.9887 17.9061 62.0826 0 39.9944 0C17.9061 0 0 17.9061 0 39.9944C0 62.0826 17.9061 79.9887 39.9944 79.9887Z",
    fill: "url(#paint0_linear_3426_563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6331 35.5468L57.7394 17.6548",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5972 23.6828C43.8416 23.6828 45.661 21.8634 45.661 19.619C45.661 17.3747 43.8416 15.5552 41.5972 15.5552C39.3529 15.5552 37.5334 17.3747 37.5334 19.619C37.5334 21.8634 39.3529 23.6828 41.5972 23.6828Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7528 37.6577C57.9992 37.6577 59.8279 35.829 59.8279 33.5826C59.8279 31.3363 57.9992 29.5076 55.7528 29.5076C53.5064 29.5076 51.6777 31.3363 51.6777 33.5826C51.6777 35.829 53.5064 37.6577 55.7528 37.6577Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0312 38.8881H21.4702C23.0506 38.8881 24.3374 40.175 24.3374 41.7553V61.6791H14.0312V38.8881Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3374 43.2341L33.6389 40.2991L49.5893 48.6073C54.0481 50.9327 50.7407 57.367 46.2367 55.019L36.7432 50.0635L34.1808 51.6777",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4021 54.6691L62.4918 49.2056C67.7747 46.8238 70.5629 54.0257 65.63 56.2269L50.2892 63.0902C45.2321 65.551 39.9717 65.98 36.0095 63.9142L24.3262 57.8072",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3426_563",
    x1: 39.9944,
    y1: 0,
    x2: 39.9944,
    y2: 79.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D008B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3426_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscounts);
export default __webpack_public_path__ + "static/media/discounts.de06f698759097c68b1069876683b479.svg";
export { ForwardRef as ReactComponent };